/* eslint-disable default-case */
import "../Styles/MainPage.css";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import chicken from "../Images/LandingPage.svg";
import chickenEn from "../Images/LandingPageEn.svg";
import logoAr from "../Images/fullLogoAr.svg";
import logoEn from "../Images/fullLogoEn.svg";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AiOutlineGlobal } from "react-icons/ai";
import BeatLoader from "react-spinners/BeatLoader";
import { setLanguage } from "../store/action/language/language";
import { useDispatch, useSelector } from "react-redux";
import { fetchBasket } from "../store/action/cart/cart";
import { fetchBranchData } from "../store/action/cart/editCart";
import langicon from '../Images/langicon.svg'
import newOrderIcon from '../Images/newOrderIcon.svg'
import newLogoIcon from '../Images/newLogo.svg'
import openionIcon from '../Images/openion.svg'
import tableIcon from '../Images/table.svg'

import LandingPageCard from '../Components/CardLandingPage'
import Effect from '../Images/effect.svg'
import LanguageSelector from '../Components/LanguageSelector'




import RateIcon from '../Images/RateIcon.svg'


function LandingPage() {
  const { t, i18n } = useTranslation();
  const [typId, setTypId] = useState(null);
  const [tableId, setTableId] = useState(null);
  const [tableName, setTableName] = useState(null);
  
  var dt = new Date();
  const year = dt.getFullYear();
  const dispatch = useDispatch();
  let history = useNavigate();
  const { lang, dir } = useSelector((state) => state.language);

  const languageState = useSelector((state) => state.language);
  const { branch, loading, error } = useSelector((state) => state.cart);
  const [menuVisible, setMenuVisible] = useState(false);

  //get branch id , type id and table id(if exists) from url (to be used in changing display in landing screen and in creating an order)
  //branch_data api call takes branch id ()=> fetch branch data
  //set language, document direction and webpage title (for when user changes language in MainPage screen then returns to this screen so both screens would have same language)
  useEffect(() => {
    const processParams = async () => {
      const dt = new Date();

      const formatter = new Intl.DateTimeFormat("en-GB", {
        timeZone: "Asia/Riyadh",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      });

      const parts = formatter.formatToParts(dt);
      let year, month, day, hour, minute, second;

      for (const part of parts) {
        switch (part.type) {
          case "year":
            year = part.value;
            break;
          case "month":
            month = part.value;
            break;
          case "day":
            day = part.value;
            break;
          case "hour":
            hour = part.value;
            break;
          case "minute":
            minute = part.value;
            break;
          case "second":
            second = part.value;
            break;
        }
      }

      const formattedRiyadhTime = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
      localStorage.setItem("landingPageVisitTime", formattedRiyadhTime);

      i18n.changeLanguage(lang);
      document.getElementById("root").style.direction = dir;

      const search = window.location.search;
      const params = new URLSearchParams(search);

      const urlBranchId = params.get("branchId");
      const urlTypeId = params.get("typeId");
      const urlTableId = params.get("tableId");
      const urlTableName = params.get("tableName");

      let branchId = urlBranchId || localStorage.getItem("branchId");
      let typeId = urlTypeId || localStorage.getItem("typeId");
      let tableId = urlTableId || localStorage.getItem("tableId");
      let tableNameFromUrl = urlTableName || localStorage.getItem("tableName");

      // If URL has parameters (coming from QR), validate and store them
      if (search && (urlBranchId || urlTypeId || urlTableId || urlTableName)) {
        if (!urlBranchId || !urlTypeId) {
          history("/scan");
          return;
        }

        if (urlTypeId !== "1" && urlTypeId !== "3" && urlTypeId !== "5") {
          history("/scan");
          return;
        }

        if (urlTypeId === "5") {
          if (!urlTableId || !urlTableName) {
            history("/scan");
            return;
          }
        }

        branchId = urlBranchId;
        typeId = urlTypeId;
        tableId = urlTableId;
        tableNameFromUrl = urlTableName;

        localStorage.setItem("branchId", branchId);
        localStorage.setItem("typeId", typeId);

        if (typeId === "5") {
          localStorage.setItem("tableId", tableId);
          localStorage.setItem("tableName", tableNameFromUrl || "");
        } else {
          localStorage.removeItem("tableId");
          localStorage.removeItem("tableName");
        }

        // Clean the URL so the user doesn't see params (use React Router so the address bar updates)
        history("/LandingPage", { replace: true });
      }

      // If still no required data, send user to scan page
      if (!branchId || !typeId) {
        history("/scan");
        return;
      }

      setTypId(typeId);
      if (typeId === "5" && tableId) {
        setTableId(tableId);
        setTableName(tableNameFromUrl);
      }

      dispatch(fetchBranchData(branchId));

      const title =
        i18n.language === "ar" ? "مطاعم الرومانسية" : "Al Romansiah Restaurant";
      document.title = title;
    };

    processParams();
  }, [dispatch, history, i18n, lang, dir]);


  useEffect(() => {
    // Only redirect to scan on error if user didn't manually enter valid URL params
    // This prevents redirect when user enters URL like ?branchId=1&tableId=1&tableName=1&typeId=5
    if (error) {
      // Check if we have valid URL params by checking the current URL
      const currentSearch = window.location.search;
      const currentParams = new URLSearchParams(currentSearch);
      
      // Read individual params directly
      const branchIdFromUrl = currentParams.get("branchId");
      const typeIdFromUrl = currentParams.get("typeId");
      const tableIdFromUrl = currentParams.get("tableId");
      const tableNameFromUrl = currentParams.get("tableName");
      
      const hasValidParams = currentSearch && 
        branchIdFromUrl && 
        typeIdFromUrl && 
        (parseInt(typeIdFromUrl, 10) === 1 || 
         parseInt(typeIdFromUrl, 10) === 3 ||
         (parseInt(typeIdFromUrl, 10) === 5 && tableIdFromUrl && tableNameFromUrl));

      // If we already cleaned the URL (history("/LandingPage", { replace: true })),
      // we still want to avoid redirecting when we have valid params in localStorage.
      const branchIdFromStorage = localStorage.getItem("branchId");
      const typeIdFromStorage = localStorage.getItem("typeId");
      const tableIdFromStorage = localStorage.getItem("tableId");
      const tableNameFromStorage = localStorage.getItem("tableName");
      const hasValidStoredParams =
        branchIdFromStorage &&
        typeIdFromStorage &&
        (parseInt(typeIdFromStorage, 10) === 1 ||
          parseInt(typeIdFromStorage, 10) === 3 ||
          (parseInt(typeIdFromStorage, 10) === 5 &&
            tableIdFromStorage &&
            tableNameFromStorage));
      
      // Only redirect if we don't have valid URL params
      if (!hasValidParams && !hasValidStoredParams) {
        console.log('Redirecting to scan due to error, no valid URL params');
        history('/scan');
      } else {
        console.log('Error occurred but valid URL params present, staying on page');
      }
    }
  }, [error, history])

  useEffect(() => {
    if (!branch) return;

    const isValidBranchPayload =
      typeof branch === "object" &&
      !Array.isArray(branch) &&
      (typeof branch?.enName === "string" ||
        typeof branch?.arName === "string");

    if (isValidBranchPayload) {
      localStorage.setItem("branch", JSON.stringify(branch));
    } else {
      // If the backend returns HTML (ex: Cloudflare challenge), don't persist it.
      localStorage.removeItem("branch");
    }
  }, [branch]);



  const toggleMenu = () => {
    setMenuVisible(!menuVisible);
  };

  const handleLanguageChange = (lang, dir) => {
    changeLanguage(lang, dir);
    setMenuVisible(false);
  };
  const menuStyle = {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#fff",
    padding: "10px",
    borderRadius: "5px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    position: "absolute",
    top: "100%",
    left: 0,
    zIndex: 1000,
  };

  const buttonStyle = {
    border: "none",
    backgroundColor: "#fff",
    cursor: "pointer",
    padding: "10px 20px",
    textAlign: "left",
    width: "100%",
    marginBottom: "5px",
  };

  const lastButtonStyle = {
    ...buttonStyle,
    marginBottom: 0,
  };

  //change language and direction
  const changeLanguage = (language, direction) => {
    i18n.changeLanguage(language);
    dispatch(setLanguage(language, direction));
    document.getElementById("root").style.direction = direction;
  };

  return (
    <>
      {loading && (
        <div className="loader">
          <BeatLoader color={"#E57200"} loading={loading} size={30} />
        </div>
      )}
      <div dir={i18n.language == "ar" || i18n.language == "ur" ? 'rtl' : 'ltr'}
        className="min-h-screen bg-white  pt-4 flex flex-col justify-between"
      >

        <div className="px-3" >
          <LanguageSelector />
        </div>

        <div className="flex px-6 flex-col gap-3 w-full  justify-center items-center " >
          <img src={newLogoIcon} className="w-56" />
          {branch && (
            <div className=" text-center ">
              <span class="text-yellow-950 text-xl font-semibold font-cairo leading-7">{t('LandingPage.welcome')}</span>
              <span class="text-[#E57200] text-xl font-semibold font-cairo leading-7">
                {i18n.language == "ar" || i18n.language == "ur"
                  ? "" + branch.arName + " "
                  : "" + branch.enName + " "}
              </span></div>
          )}

          <div className="flex flex-col w-full gap-1" >
            <LandingPageCard
              title={t("newOrder")}
              subtitle={
                typId == 5 
                  ? t("LandingPage.type2") + " " + `   #${tableName || localStorage.getItem("tableName") || ""}` 
                  : typId == 3 
                    ? t("LandingPage.type3")
                    : t("LandingPage.type1")
              }
              icon={newOrderIcon}
              onClick={() => {
                history('/menu')
              }}
            />
            {typId == 5 && (
              <>
                <LandingPageCard
                  title={t("LandingPage.yourOpinionMatters")}
                  subtitle={t("LandingPage.opinionSubtitle")}
                  icon={openionIcon}
                  onClick={() => {
                    // Get referenceNo from branch data and tableName from URL params
                    const referenceNo = branch?.referenceNo || "";
                    const currentTableName = tableName || localStorage.getItem("tableName") || "";
                    
                    if (referenceNo && currentTableName) {
                      // Navigate to survey URL with referenceNo and tableName
                      const surveyUrl = `https://alromansiahcare.com/survey-rate-ar/${referenceNo}/?type=table-qr&s=32&n=${currentTableName}&m=&o=${currentTableName}`;
                      window.open(surveyUrl, '_blank');
                    } else {
                      console.error("Missing referenceNo or tableName", { referenceNo, currentTableName });
                    }
                  }}
                />
                {branch?.tableServices === true && (
                  <LandingPageCard
                    title={t("LandingPage.sessionServicesTitle")}
                    subtitle={t("LandingPage.sessionServicesSubtitles")}
                    icon={tableIcon}
                    onClick={() => {
                      history("/table-services");
                    }}
                  />
                )}
              </>
            )}
            {/* <LandingPageCard
              title={t('giveUsYouropinion')}
              subtitle={t('tellUsWhatYouSee')}
              icon={RateIcon}
              onClick={() => console.log("New order clicked")}
            /> */}
          </div>
        </div>




        <div className="w-full sm:w-[500px] pt-5 mb-2 self-center " >
          <img src={Effect} className="w-full " />
        </div>

      </div>
    </>




  );
}

export default LandingPage;


//  <div className="MainMenu ">
//       {loading ? (
//         <div className="loader">
//           <BeatLoader color={"#E57200"} loading={loading} size={30} />
//         </div>
//       ) : (
//         <>
//           <div
//             className={
//               languageState.lang === "ar" || languageState.lang == "ur"
//                 ? "langSwitch landingLang landingLangAr"
//                 : "langSwitch landingLang"
//             }
//           >
//             <div
//               className="langBtns"
//               onClick={toggleMenu}
//               style={{ margin: "0", position: "relative" }}
//             >
//               <AiOutlineGlobal className="globe" size={25} />
//               <button className="langBtn">
//                 {languageState.lang.toUpperCase()}
//               </button>
//             </div>
//             {menuVisible && (
//               <div style={menuStyle}>
//                 <button
//                   style={buttonStyle}
//                   onClick={() => handleLanguageChange("en", "rtl")}
//                 >
//                   EN
//                 </button>
//                 <button
//                   style={buttonStyle}
//                   onClick={() => handleLanguageChange("ar", "ltr")}
//                 >
//                   AR
//                 </button>
//                 <button
//                   style={buttonStyle}
//                   onClick={() => handleLanguageChange("id", "rtl")}
//                 >
//                   ID
//                 </button>
//                 <button
//                   style={buttonStyle}
//                   onClick={() => handleLanguageChange("ur", "ltr")}
//                 >
//                   UR
//                 </button>
//               </div>
//             )}
//           </div>
//           <div
//             className={
//               languageState.lang == "ar" || languageState.lang == "ur"
//                 ? "landingForm container-fluid"
//                 : "landingForm landingFormEn container-fluid"
//             }
//           >
//             <div className="">
//               <div className="" style={{ position: "relative" }}>
//                 <img
//                   src={
//                     i18n.language == "ar" ||
//                       i18n.language == "ur" ||
//                       i18n.language == "ur"
//                       ? chicken
//                       : chickenEn
//                   }
//                   className="lpImage"
//                 />
//               </div>
//               <div className="lpAlign" style={{ position: "relative" }}>
//                 <form
//                   style={
//                     languageState.lang == "ar" || languageState.lang == "ur"
//                       ? { direction: "ltr" }
//                       : { direction: "rtl", paddingLeft: "1em" }
//                   }
//                 >
//                   <img
//                     src={
//                       i18n.language == "ar" || i18n.language == "ur"
//                         ? logoAr
//                         : logoEn
//                     }
//                     className="lpLogo"
//                   />
//                   {/*<div  className='logoDiv' style={{ backgroundImage: `url(${i18n.language=="ar"?logoAr:logoEn})` }}>

// </div>*/}

//                   <p className="welcome">
//                     {" "}
//                     <span className="brnchName">
//                       {i18n.language == "ar" || i18n.language == "ur"
//                         ? "!" + branch.arName + " "
//                         : "!" + branch.enName + " "}
//                     </span>{" "}
//                     {t("LandingPage.welcome")}{" "}
//                   </p>
//                   {typId == 5 ? (
//                     <p className="qrType">
//                       {t("LandingPage.order")} {t("LandingPage.type2")}{" "}
//                     </p>
//                   ) : (
//                     <p className="qrType">
//                       {t("LandingPage.order")} {t("LandingPage.type1")}{" "}
//                     </p>
//                   )}
//                   {typId == 5 ? (
//                     <p className="qrType">
//                       {t("LandingPage.table")} {tableName}{" "}
//                     </p>
//                   ) : null}
//                   {/*

// <input value={formik.values.phone} type="text" id="phone" name="phone" placeholder={t("LandingPage.input")}  ref={phoneRef} required={true} onChange={formik.handleChange} onBlur={formik.handleBlur} style={language.language=="ar"?{textAlign:'right',paddingRight:"15px",direction:"rtl"}:{textAlign:'left',direction:"ltr",paddingLeft:"15px"}}/>
// <span>{formik.errors.phone && formik.touched.phone?t("LandingPage.validation"):null}</span>
// */}

//                   <div
//                     className={
//                       i18n.language == "ar" || i18n.language == "ur"
//                         ? "lpBtn"
//                         : "lpBtn lpBtnEn"
//                     }
//                   >
//                     <Link to="/menu">
//                       <button type="button">{t("LandingPage.button")}</button>
//                     </Link>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>{" "}
//         </>
//       )}

//       <div className="footerLink">
//         <p>
//           {t("LandingPage.powered")}{" "}
//           <a
//             target="_blank"
//             style={
//               i18n.language == "ar" || i18n.language == "ur"
//                 ? { marginRight: "5px" }
//                 : { marginLeft: "5px" }
//             }
//             href="https://www.bdaiat.com/"
//           >
//             {" "}
//             {t("LandingPage.bdaiat")}
//           </a>
//         </p>
//         <p>
//           {t("LandingPage.copy_write_parg")} <span>© {year} </span>{" "}
//         </p>
//       </div>
//     </div>
